import IndexSkusCarouselSkeleton from '@/components/common/Skeleton/IndexSkusCarouselSkeleton';
import { memo, useRef } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Navigation, Virtual } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import IndexSkuCard from '@/components/home/Index/IndexSkuCard';
import { SkuDTO } from '@/types/api/sku';
import 'swiper/css/navigation';

export type SkusCommonCarouselProps = {
  skus: SkuDTO[];
  isLoading?: boolean;
  isRelease?: boolean;
} & Omit<SwiperProps, 'children'>;

function SkusCommonCarousel({
  skus,
  isLoading,
  isRelease,
  ...swiperOptions
}: SkusCommonCarouselProps) {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  const defaultSwiperConfig = {
    ...swiperOptions,
    modules: [Virtual, Navigation, ...(swiperOptions?.modules || [])],
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      350: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      430: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      716: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      886: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      ...swiperOptions.breakpoints,
    },
    loop: skus.length > 4,
    className:
      '!tw-h-fit max-nine:tw-h-[300px] tw-relative !tw-overflow-x-clip !tw-overflow-y-visible',
    virtual: false,
    navigation: {
      prevEl: prevRef.current,
      nextEl: nextRef.current,
    },
    onBeforeInit: (swiper: any) => {
      if (swiper.params.navigation) {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
      }
    },
    ...swiperOptions,
  };

  if (isLoading) {
    return <IndexSkusCarouselSkeleton />;
  }

  return (
    <div className="tw-relative tw-w-full max-nine:tw-pl-4">
      <Swiper {...defaultSwiperConfig}>
        {skus.map((sku, index) => (
          <SwiperSlide
            key={sku.id}
            virtualIndex={index}
            className="!tw-h-[460px] tw-max-w-[45vw] tw-pr-0.5 max-nine:!tw-h-auto"
          >
            <IndexSkuCard sku={sku} isRelease={isRelease} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default memo(SkusCommonCarousel);
